import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT_BG_IMG } from "../data/site";

export const SectionLabel = ({ children, className = "" }) => (
  <span className={`inline-block text-xs uppercase tracking-[0.35em] text-ofc-gold ${className}`}>
    {children}
  </span>
);

export const PageHero = ({ label, title, subtitle, image }) => (
  <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ofc-black via-ofc-black/80 to-ofc-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ofc-black via-transparent to-ofc-black/60" />
      </div>
    )}
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        {label && <SectionLabel>{label}</SectionLabel>}
        <h1 className="font-serif-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] mt-6 max-w-4xl text-balance">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 text-base md:text-lg text-white/60 font-light leading-relaxed max-w-2xl">
            {subtitle}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);

export const ContactCTA = ({
  title = "Iniciem una conversa reservada",
  text = "Cada projecte comença amb una escolta atenta i confidencial. Expliqueu-nos els vostres objectius internacionals.",
}) => (
  <section className="relative bg-ofc-navy border-t border-white/5 overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img src={CONTACT_BG_IMG} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-ofc-black via-ofc-black/90 to-ofc-black/50" />
      <div className="absolute inset-0 bg-gradient-to-t from-ofc-black/80 via-transparent to-ofc-black/40" />
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal className="max-w-3xl">
        <SectionLabel>Contacte</SectionLabel>
        <h2 className="font-serif-display font-light text-3xl md:text-5xl tracking-tight mt-6 leading-tight">
          {title}
        </h2>
        <p className="mt-6 text-white/60 font-light leading-relaxed">{text}</p>
        <Link
          to="/contacte"
          data-testid="cta-contact-button"
          className="mt-10 inline-flex items-center gap-3 bg-ofc-gold text-ofc-black px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-ofc-goldhover transition-colors duration-300 group"
        >
          Sol·licitar consulta
          <ArrowRight size={16} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </Reveal>
    </div>
  </section>
);
